import React from 'react';
import { TrendingUp } from 'lucide-react';
import { ProductCard } from '../ProductCard';
import { tileGridStyle } from '../../utils/gridStyles';
import { useFontSizes } from '../../contexts/FontSizeContext';
import { useI18n } from '../../i18n/I18nContext';
import type { WidgetProps } from './types';

export const BestSellerWinesWidget: React.FC<WidgetProps> = ({ config, defaults, onProductClick, itemsPerRow }) => {
  const { heading } = useFontSizes();
  const { t } = useI18n();
  const products = defaults?.bestSellers ?? [];
  const items = config.maxItems ? products.slice(0, config.maxItems) : products.slice(0, 8);

  if (items.length === 0) return null;

  return (
    <section className="mb-8">
      <h2 className={`flex items-center gap-2 ${heading} font-semibold uppercase tracking-wider text-[#020202] mb-4`}>
        <TrendingUp className="h-4 w-4" />
        {config.title ?? t('defaults.bestSellers')}
      </h2>
      <div style={tileGridStyle('medium', itemsPerRow ?? 4)}>
        {items.map((product, index) => (
          <div
            key={product.id}
            className="animate-fade-in"
            style={{ animationDelay: `${index * 40}ms` }}
          >
            <ProductCard product={product} onProductClick={onProductClick} />
          </div>
        ))}
      </div>
    </section>
  );
};
